<template>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="24" 
    height="25" 
    viewBox="0 0 24 25" 
    fill="none"
    :class="direction"
  >
    <path 
      d="M14 16.5L18 12.5M18 12.5L14 8.5M18 12.5L6 12.5" 
      :stroke="color" 
      stroke-width="1.5" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#FFF'
    },
    direction: {
      type: String,
      default: 'right'
    }
  }
}
</script>

<style lang="scss" scoped>
svg {
  &.up {
    transform: rotate(-90deg);
  }

  &.down {
    transform: rotate(90deg);
  }

  &.left {
    transform: rotate(180deg);
  }
}
</style>